export default "/images/02bda83fd1f35fb1e0289ca260d4bb03.jpg";